/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Handlebars from 'handlebars';
import 'react-dropdown/style.css';
import { HandlebarsContext, registerHelpers } from '../../configs/handleBarHelpers';

registerHelpers();

interface Props {
    code: string;
    testData: string;
    onParse: (html: string) => void;
}
function HtmlPreviewer(props: Props) {
    const [_parsedHtml, _setParsedHtml] = useState(props.code);

    useEffect(() => {
        try {
            const handlebarsTemplate = Handlebars.compile(props.code);
            const parsedHtml = handlebarsTemplate(props.testData ? JSON.parse(props.testData) : {});

            _setParsedHtml(parsedHtml);
            props.onParse(parsedHtml);
        } catch (e) {
            console.error(e);
        }
    }, [props.code, props.testData])

    return (
        <div dangerouslySetInnerHTML={{
            __html: _parsedHtml
        }}>
        </div>
    )
}

export default HtmlPreviewer;